import { Label } from '../Form';
import { Flex } from 'rebass';
import EmailInputGroup from './EmailInputGroup';
import { UtilityIconButton } from '../Button/UtilityIconButton';
import React from 'react';
import { EmailInput, PhoneInput } from './types';

type EditEmailsProps = {
  emails: EmailInput[];
  labels?: boolean;
  singleEmail?: boolean;
  disabled?: boolean;
  handleContactChange: (
    type: 'phone' | 'email',
    value: PhoneInput | EmailInput,
    index: number
  ) => void;
  handleAddPhoneOrEmail: (e: any) => void;
  handleDeletePhoneOrEmail: (idx: number, type: 'phones' | 'emails') => void;
};

const EditEmails: React.FC<EditEmailsProps> = ({
  emails,
  labels,
  singleEmail,
  disabled,
  handleContactChange,
  handleDeletePhoneOrEmail,
  handleAddPhoneOrEmail,
}) => {
  return (
    <>
      {labels && <Label>Email{singleEmail ? '' : 's'}</Label>}
      {emails &&
        emails.map((email, idx) => (
          <Flex
            key={idx}
            mb={1}
            sx={{
              alignItems: 'center',
            }}
          >
            <EmailInputGroup
              mr={singleEmail ? 0 : 1}
              index={idx}
              value={email}
              onChange={handleContactChange}
              inputProps={{ disabled }}
            />
            {!singleEmail && !disabled && (
              <UtilityIconButton
                dark
                title="Remove Email"
                icon="x"
                onClick={(e: any) => handleDeletePhoneOrEmail(idx, 'emails')}
              />
            )}
          </Flex>
        ))}
      {!disabled && (!singleEmail || emails.length === 0) && (
        <UtilityIconButton
          dark
          title="Add Phone"
          icon="plus"
          name="emails"
          alignSelf="flex-start"
          onClick={handleAddPhoneOrEmail}
        />
      )}
    </>
  );
};

export default EditEmails;
